import type { GutXAxisFlagLevel, OrganLookupCode } from '@repo/types';
import { AgeGroup, getAgeGroup, getAgeInYears } from '@repo/utils';

import adultHeartHigh from '#assets/images/gutXAxis/adult/heart-high.webp';
import adultHeartLow from '#assets/images/gutXAxis/adult/heart-low.webp';
import adultHeartModerate from '#assets/images/gutXAxis/adult/heart-moderate.webp';
import adultImmuneHigh from '#assets/images/gutXAxis/adult/immune-high.svg';
import adultImmuneLow from '#assets/images/gutXAxis/adult/immune-low.svg';
import adultImmuneModerate from '#assets/images/gutXAxis/adult/immune-moderate.svg';
import intestinesUterusFullHigh from '#assets/images/gutXAxis/adult/intestines-uterus-full-high.webp';
import intestinesUterusFullLow from '#assets/images/gutXAxis/adult/intestines-uterus-full-low.webp';
import intestinesUterusFullModerate from '#assets/images/gutXAxis/adult/intestines-uterus-full-moderate.webp';
import intestinesWithUterusHigh from '#assets/images/gutXAxis/adult/intestines-with-uterus-high.webp';
import intestinesWithUterusLow from '#assets/images/gutXAxis/adult/intestines-with-uterus-low.webp';
import intestinesWithUterusModerate from '#assets/images/gutXAxis/adult/intestines-with-uterus-moderate.webp';
import adultKidneyHigh from '#assets/images/gutXAxis/adult/kidney-high.webp';
import adultKidneyLow from '#assets/images/gutXAxis/adult/kidney-low.webp';
import adultKidneyModerate from '#assets/images/gutXAxis/adult/kidney-moderate.webp';
import adultLiverHigh from '#assets/images/gutXAxis/adult/liver-high.webp';
import adultLiverLow from '#assets/images/gutXAxis/adult/liver-low.webp';
import adultLiverModerate from '#assets/images/gutXAxis/adult/liver-moderate.webp';
import adultLungsHigh from '#assets/images/gutXAxis/adult/lungs-high.webp';
import adultLungsLow from '#assets/images/gutXAxis/adult/lungs-low.webp';
import adultLungsModerate from '#assets/images/gutXAxis/adult/lungs-moderate.webp';
import adultMetabolicHigh from '#assets/images/gutXAxis/adult/metabolic-high.svg';
import adultMetabolicLow from '#assets/images/gutXAxis/adult/metabolic-low.svg';
import adultMetabolicModerate from '#assets/images/gutXAxis/adult/metabolic-moderate.svg';
import adultMusculoskeletalHigh from '#assets/images/gutXAxis/adult/musculoskeletal-high.webp';
import adultMusculoskeletalLow from '#assets/images/gutXAxis/adult/musculoskeletal-low.webp';
import adultMusculoskeletalModerate from '#assets/images/gutXAxis/adult/musculoskeletal-moderate.webp';
import fetusHigh from '#assets/images/gutXAxis/adult/pregnant/fetus-high.webp';
import fetusLow from '#assets/images/gutXAxis/adult/pregnant/fetus-low.webp';
import fetusModerate from '#assets/images/gutXAxis/adult/pregnant/fetus-moderate.webp';
import intestinesBabyFullHigh from '#assets/images/gutXAxis/adult/pregnant/intestines-baby-full-high.webp';
import intestinesBabyFullLow from '#assets/images/gutXAxis/adult/pregnant/intestines-baby-full-low.webp';
import intestinesBabyFullModerate from '#assets/images/gutXAxis/adult/pregnant/intestines-baby-full-moderate.webp';
import intestinesWithBabyHigh from '#assets/images/gutXAxis/adult/pregnant/intestines-with-baby-high.webp';
import intestinesWithBabyLow from '#assets/images/gutXAxis/adult/pregnant/intestines-with-baby-low.webp';
import intestinesWithBabyModerate from '#assets/images/gutXAxis/adult/pregnant/intestines-with-baby-moderate.webp';
import adultThyroidHigh from '#assets/images/gutXAxis/adult/thyroid-high.webp';
import adultThyroidLow from '#assets/images/gutXAxis/adult/thyroid-low.webp';
import adultThyroidModerate from '#assets/images/gutXAxis/adult/thyroid-moderate.webp';
import uterusHigh from '#assets/images/gutXAxis/adult/uterus-high.webp';
import uterusLow from '#assets/images/gutXAxis/adult/uterus-low.webp';
import uterusModerate from '#assets/images/gutXAxis/adult/uterus-moderate.webp';
import babyToddlerImmuneHigh from '#assets/images/gutXAxis/baby-toddler/immune-high.svg';
import babyToddlerImmuneLow from '#assets/images/gutXAxis/baby-toddler/immune-low.svg';
import babyToddlerImmuneModerate from '#assets/images/gutXAxis/baby-toddler/immune-moderate.svg';
import adultBody from '#assets/images/gutXAxis/bodies/adult.webp';
import babyToddlerBody from '#assets/images/gutXAxis/bodies/baby-toddler.webp';
import childBody from '#assets/images/gutXAxis/bodies/child.webp';
import childImmuneHigh from '#assets/images/gutXAxis/child/immune-high.svg';
import childImmuneLow from '#assets/images/gutXAxis/child/immune-low.svg';
import childImmuneModerate from '#assets/images/gutXAxis/child/immune-moderate.svg';
import paediatricLungsHigh from '#assets/images/gutXAxis/paediatric/lungs-high.webp';
import paediatricLungsLow from '#assets/images/gutXAxis/paediatric/lungs-low.webp';
import paediatricLungsModerate from '#assets/images/gutXAxis/paediatric/lungs-moderate.webp';
import brainHigh from '#assets/images/gutXAxis/shared/brain-high.webp';
import brainLow from '#assets/images/gutXAxis/shared/brain-low.webp';
import brainModerate from '#assets/images/gutXAxis/shared/brain-moderate.webp';
import intestinesFullHigh from '#assets/images/gutXAxis/shared/intestines-full-high.webp';
import intestinesFullLow from '#assets/images/gutXAxis/shared/intestines-full-low.webp';
import intestinesFullModerate from '#assets/images/gutXAxis/shared/intestines-full-moderate.webp';
import intestinesHigh from '#assets/images/gutXAxis/shared/intestines-high.webp';
import intestinesLow from '#assets/images/gutXAxis/shared/intestines-low.webp';
import intestinesModerate from '#assets/images/gutXAxis/shared/intestines-moderate.webp';
import skinHigh from '#assets/images/gutXAxis/shared/skin-high.svg';
import skinLow from '#assets/images/gutXAxis/shared/skin-low.svg';
import skinModerate from '#assets/images/gutXAxis/shared/skin-moderate.svg';
import stomachFullHigh from '#assets/images/gutXAxis/shared/stomach-full-high.webp';
import stomachFullLow from '#assets/images/gutXAxis/shared/stomach-full-low.webp';
import stomachFullModerate from '#assets/images/gutXAxis/shared/stomach-full-moderate.webp';
import stomachHigh from '#assets/images/gutXAxis/shared/stomach-high.webp';
import stomachLow from '#assets/images/gutXAxis/shared/stomach-low.webp';
import stomachModerate from '#assets/images/gutXAxis/shared/stomach-moderate.webp';

export type GutXAxisArtwork = Record<GutXAxisFlagLevel, string>;

/** Keyed on `organs.lookup_code`, so a key that drifts from the DB won't compile. */
type ArtworkByOrgan = Partial<Record<OrganLookupCode, GutXAxisArtwork>>;

const AGE_INVARIANT_ORGANS: ArtworkByOrgan = {
  brain: { low: brainLow, moderate: brainModerate, high: brainHigh },
  skin: { low: skinLow, moderate: skinModerate, high: skinHigh },
};

/** Drawn for adults only. Identical for pregnant and non-pregnant. */
const ADULT_ONLY_ORGANS: ArtworkByOrgan = {
  endocrine: {
    low: adultThyroidLow,
    moderate: adultThyroidModerate,
    high: adultThyroidHigh,
  },
  heart: {
    low: adultHeartLow,
    moderate: adultHeartModerate,
    high: adultHeartHigh,
  },
  kidney: {
    low: adultKidneyLow,
    moderate: adultKidneyModerate,
    high: adultKidneyHigh,
  },
  liver: {
    low: adultLiverLow,
    moderate: adultLiverModerate,
    high: adultLiverHigh,
  },
  metabolic: {
    low: adultMetabolicLow,
    moderate: adultMetabolicModerate,
    high: adultMetabolicHigh,
  },
  muscle: {
    low: adultMusculoskeletalLow,
    moderate: adultMusculoskeletalModerate,
    high: adultMusculoskeletalHigh,
  },
};

/**
 * Organs the design file draws as half of a symmetric shape, cut at the midline,
 * so one drawing is placed twice and the second copy flipped. The parts are the
 * CSS keys; the first carries the system's dot, the second hides its own.
 */
const MIRRORED_PAIRS: Partial<Record<OrganLookupCode, [string, string]>> = {
  immune: ['immune1', 'immune2'],
  kidney: ['kidney1', 'kidney2'],
  metabolic: ['metabolic1', 'metabolic2'],
};

const PAEDIATRIC_LUNGS: GutXAxisArtwork = {
  low: paediatricLungsLow,
  moderate: paediatricLungsModerate,
  high: paediatricLungsHigh,
};

const BABY_TODDLER_IMMUNE: GutXAxisArtwork = {
  low: babyToddlerImmuneLow,
  moderate: babyToddlerImmuneModerate,
  high: babyToddlerImmuneHigh,
};

const ORGANS_BY_AGE_GROUP: Partial<
  Record<OrganLookupCode, Record<AgeGroup, GutXAxisArtwork>>
> = {
  immune: {
    [AgeGroup.BABY]: BABY_TODDLER_IMMUNE,
    [AgeGroup.TODDLER]: BABY_TODDLER_IMMUNE,
    [AgeGroup.CHILD]: {
      low: childImmuneLow,
      moderate: childImmuneModerate,
      high: childImmuneHigh,
    },
    [AgeGroup.ADULT]: {
      low: adultImmuneLow,
      moderate: adultImmuneModerate,
      high: adultImmuneHigh,
    },
  },
  lung: {
    [AgeGroup.BABY]: PAEDIATRIC_LUNGS,
    [AgeGroup.TODDLER]: PAEDIATRIC_LUNGS,
    [AgeGroup.CHILD]: PAEDIATRIC_LUNGS,
    [AgeGroup.ADULT]: {
      low: adultLungsLow,
      moderate: adultLungsModerate,
      high: adultLungsHigh,
    },
  },
};

const GUT: GutXAxisArtwork = {
  low: intestinesLow,
  moderate: intestinesModerate,
  high: intestinesHigh,
};

/**
 * The intestines and stomach as drawn once the liver and kidneys are on the body:
 * both lose the sections those organs cover, so they cannot be used on their own —
 * without something behind them the cuts read as holes in the gut.
 *
 * Figma draws two states only, the MVP set and this one, so any partial
 * combination falls back to whichever of the two is closer. It recuts the
 * intestines once per body type, and nothing else: liver, kidney, musculoskeletal
 * and the recut stomach are one drawing each, shared by every adult body.
 */
const GUT_FULL: GutXAxisArtwork = {
  low: intestinesFullLow,
  moderate: intestinesFullModerate,
  high: intestinesFullHigh,
};

/** `GUT_FULL` with the sigmoid tail dropped as well, to clear the uterus. */
const GUT_UTERUS_FULL: GutXAxisArtwork = {
  low: intestinesUterusFullLow,
  moderate: intestinesUterusFullModerate,
  high: intestinesUterusFullHigh,
};

/** The pregnant recut, on the same canvas as the uncut intestines-with-baby. */
const GUT_BABY_FULL: GutXAxisArtwork = {
  low: intestinesBabyFullLow,
  moderate: intestinesBabyFullModerate,
  high: intestinesBabyFullHigh,
};

const STOMACH_FULL: GutXAxisArtwork = {
  low: stomachFullLow,
  moderate: stomachFullModerate,
  high: stomachFullHigh,
};

/**
 * The design file's pre-composited intestines-and-uterus. Nothing consumes it: the
 * body layers `gut` and `reproductive` separately so each can show its own flag
 * level, and the uterus now has three states of its own. Dead unless the flattened
 * pair turns out to be wanted somewhere.
 */
export const GUT_WITH_UTERUS: GutXAxisArtwork = {
  low: intestinesWithUterusLow,
  moderate: intestinesWithUterusModerate,
  high: intestinesWithUterusHigh,
};

const GUT_WITH_BABY: GutXAxisArtwork = {
  low: intestinesWithBabyLow,
  moderate: intestinesWithBabyModerate,
  high: intestinesWithBabyHigh,
};

/** The `reproductive` drawing for pregnant adults; it has no `organs` row of its own. */
const FETUS: GutXAxisArtwork = {
  low: fetusLow,
  moderate: fetusModerate,
  high: fetusHigh,
};

/** Part of `gut`: the organs table has no stomach row and its `about` spans mouth to anus. */
const STOMACH: GutXAxisArtwork = {
  low: stomachLow,
  moderate: stomachModerate,
  high: stomachHigh,
};

const UTERUS: GutXAxisArtwork = {
  low: uterusLow,
  moderate: uterusModerate,
  high: uterusHigh,
};

const BODY_BY_AGE_GROUP: Record<AgeGroup, string> = {
  [AgeGroup.BABY]: babyToddlerBody,
  [AgeGroup.TODDLER]: babyToddlerBody,
  [AgeGroup.CHILD]: childBody,
  [AgeGroup.ADULT]: adultBody,
};

export type OrganArtworkQuery = {
  lookupCode: OrganLookupCode;
  flagLevel: GutXAxisFlagLevel;
  ageGroup: AgeGroup;
  pregnant: boolean;
  /** `tinyaccount.sex`. Only F draws a uterus; O follows M, as the ticket asks. */
  sex?: string | null;
  /**
   * Every organ code the body was handed. The gut is recut where the liver and
   * kidneys overlap it, so it has to know they are coming before it picks a
   * drawing. Omit it and the gut stays on the MVP artwork.
   */
  drawnCodes?: ReadonlySet<OrganLookupCode>;
};

/**
 * One positioned drawing. An organ can own several: `gut` is the stomach and the
 * intestines, which sit in different places but share the organ's flag level.
 * `part` is the CSS positioning key and defaults to the organ's own code.
 */
export type OrganArtworkPart = {
  part: string;
  src: string;
};

type OrganArtworkContext = Omit<OrganArtworkQuery, 'lookupCode' | 'flagLevel'>;

/**
 * Whether the body is drawing an organ the gut has to make room for. Age is part
 * of it because every such organ is adult-only, which also keeps this from having
 * to ask what resolved — the gut is itself one of the answers.
 */
const isFullOrganSet = ({ ageGroup, drawnCodes }: OrganArtworkContext) =>
  ageGroup === AgeGroup.ADULT &&
  (drawnCodes?.has('liver') || drawnCodes?.has('kidney')) === true;

/**
 * Which intestines a body gets: the baby displaces them, and failing that a uterus
 * costs the sigmoid tail. Each of the three is recut again once the liver or a
 * kidney is drawn over it.
 */
const resolveIntestines = (query: OrganArtworkContext): GutXAxisArtwork => {
  const full = isFullOrganSet(query);

  if (query.ageGroup === AgeGroup.ADULT && query.pregnant) {
    return full ? GUT_BABY_FULL : GUT_WITH_BABY;
  }

  if (!full) return GUT;
  return query.sex === 'F' ? GUT_UTERUS_FULL : GUT_FULL;
};

const resolveStomach = (query: OrganArtworkContext): GutXAxisArtwork =>
  isFullOrganSet(query) ? STOMACH_FULL : STOMACH;

/** One drawing as the organ's single part, or as its mirrored pair. */
const place = (
  lookupCode: OrganLookupCode,
  src: string,
): OrganArtworkPart[] => {
  const pair = MIRRORED_PAIRS[lookupCode];
  return pair ? pair.map(part => ({ part, src })) : [{ part: lookupCode, src }];
};

/**
 * Resolves one organ to the drawings that represent it. Empty when there is no
 * artwork: `oral` was never drawn, and adult-only organs on a younger body —
 * which includes every organ the design file added after the MVP.
 */
export function getOrganImages(query: OrganArtworkQuery): OrganArtworkPart[] {
  const { lookupCode, flagLevel, ageGroup } = query;

  if (lookupCode === 'gut') {
    return [
      { part: 'gut', src: resolveIntestines(query)[flagLevel] },
      { part: 'stomach', src: resolveStomach(query)[flagLevel] },
    ];
  }

  // Adult only, and drawn as a fetus once pregnant: the spec pairs uterus and
  // baby as one body-type organ. Pregnancy alone gates the fetus, matching the
  // intestines-with-baby drawing whose gap it fills.
  if (lookupCode === 'reproductive') {
    if (ageGroup !== AgeGroup.ADULT) return [];
    if (query.pregnant) return [{ part: 'fetus', src: FETUS[flagLevel] }];
    return query.sex === 'F'
      ? [{ part: 'reproductive', src: UTERUS[flagLevel] }]
      : [];
  }

  const byAgeGroup = ORGANS_BY_AGE_GROUP[lookupCode];
  if (byAgeGroup) {
    return place(lookupCode, byAgeGroup[ageGroup][flagLevel]);
  }

  const adultOnly = ADULT_ONLY_ORGANS[lookupCode];
  if (adultOnly) {
    if (ageGroup !== AgeGroup.ADULT) return [];
    return place(lookupCode, adultOnly[flagLevel]);
  }

  const invariant = AGE_INVARIANT_ORGANS[lookupCode];
  return invariant ? place(lookupCode, invariant[flagLevel]) : [];
}

const ADULT_BODY_MIN_AGE_YEARS = 13;

/**
 * The silhouette a kit is drawn on, which is not always the age group its organs
 * come from: pregnancy is not a variant of its own, and ages 13-18 take the adult
 * body with their child organs.
 */
export function getBodyAgeGroup({
  age,
  pregnant,
}: {
  age: number;
  pregnant: boolean;
}): AgeGroup {
  return pregnant || getAgeInYears(age) >= ADULT_BODY_MIN_AGE_YEARS
    ? AgeGroup.ADULT
    : getAgeGroup(age);
}

export const getBodyImage = (bodyAgeGroup: AgeGroup): string =>
  BODY_BY_AGE_GROUP[bodyAgeGroup];
